import { BabylonState } from "../../state";

import { applyRenderOrigin } from "./applyRenderOrigin";
import { constrainCamera } from "./constrainCamera";
import { updatePositions } from "./setPositionsToTime";

/**
 * Renders the babylon scene to its canvas.
 */
export function render(state: BabylonState) {
  // Update entity positions.
  updatePositions(state);
  // Transform meshes from data-space coordinates to render-space coordinates
  applyRenderOrigin(state);
  // Constrain the camera's movement
  constrainCamera(state);

  // render the scene.
  state.context.scene.render(false);
}
